module.exports = __webpack_public_path__ + "img/42.5eb74bcb.jpg";